import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    FilterCheckboxItem,
    HorizontalFilterDropdown,
} from "../_components/HorizontalFilterDropdown";
import { Selectors } from "../_reducers/app.reducer";
import { devicesActions } from "../_actions";
import { DeviceFunctionality } from "../_helpers/DeviceFunctionality";
import { deviceIconForType } from "../_assets";

export function DeviceDevicesFilter() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const devices: any[] = useSelector(
        Selectors.getSelectedLocationDevices,
    );
    const isAllDevicesSelected = useSelector(
        Selectors.getIsAllDevicesSelected,
    );

    const visibleDevices = devices
        .filter((device) =>
            DeviceFunctionality.supportsActivity(device.type),
        )
        .filter((device) => device.show)
        .sort((a, b) =>
            a.description
                .toUpperCase()
                .localeCompare(b.description.toUpperCase()),
        );

    const activeCount = isAllDevicesSelected
        ? 0
        : visibleDevices.filter((d) => d.selected).length;

    const handleAllClick = () =>
        dispatch(devicesActions.selectAllVisibleDevices());
    const handleDeviceClick = (uid: string) =>
        dispatch(devicesActions.toggleSelectDevice(uid));

    return (
        <HorizontalFilterDropdown
            label={t("devices.devices")}
            activeCount={activeCount}
        >
            <FilterCheckboxItem
                checked={isAllDevicesSelected}
                label={t("common.all")}
                onClick={handleAllClick}
            />
            {visibleDevices.map((device) => (
                <FilterCheckboxItem
                    key={device.uid}
                    checked={!isAllDevicesSelected && device.selected}
                    label={device.description}
                    icon={{
                        src: deviceIconForType(device.type),
                        alt: "device icon",
                    }}
                    onClick={() => handleDeviceClick(device.uid)}
                />
            ))}
        </HorizontalFilterDropdown>
    );
}
